import { Facade } from "@/modules/budget/monitoring/input-forms/types/roots/Facade";
import { FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm";
import { App12FilterSettingsForm } from "@/modules/budget/monitoring/input-forms/components/application12/app12_14InputForm";
import { App19FilterSettingsForm } from "./app19InputForm";

export class App19InputFormFacade implements Facade {
    getFilterSettings(): FilterSettingsForm {
        const form: App19FilterSettingsForm = {
            user_id: "",
            edit_access: true,
            delete_access: false,
            convert: 1000,
            application: null,
            child_status: null,
        }
        return form
    }

}